import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import ProductTemplate from '../../../components/feature/ProductTemplate';
import { useSEO } from '../../../utils/seo';

const HardwarePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Wholesale Architectural Hardware | Direct Import Door Locks & Fittings | Commercial Grade',
    description: 'Direct import wholesale architectural hardware for commercial contractors and developers. Bulk door locks, handles, hinges, and cabinet hardware with factory-direct pricing. ANSI Grade 1 commercial-grade quality. Save on building materials with wholesale construction supply serving builders across Canada.',
    keywords: 'wholesale door hardware, commercial locks bulk, architectural hardware direct import, bulk construction materials supplier, direct import building materials, save on building materials, cabinet hardware wholesale',
    canonical: `${siteUrl}/products/hardware`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: 'Architectural Hardware',
      description: 'Wholesale hardware supplier offering direct import door hardware, locks, hinges, and architectural fittings from leading manufacturers. Commercial-grade quality with factory-direct pricing for bulk construction projects.',
      category: 'Hardware',
      brand: {
        '@type': 'Brand',
        name: 'Go Global Inc.',
      },
      offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'CAD',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Go Global Inc.',
        },
      },
    },
  });

  const productData = {
    category: 'Hardware',
    title: 'Architectural Hardware',
    description: 'Door hardware, locks, hinges, and architectural fittings from leading manufacturers worldwide.',
    heroImage: 'https://public.readdy.ai/ai/img_res/069f1f0676a4d4e0d80b90109785cc39.jpg',
    benefits: [
      {
        icon: 'ri-price-tag-3-line',
        title: 'Wholesale Access',
        description: 'Direct factory pricing on commercial-grade hardware systems',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Grade 1 Quality',
        description: 'Commercial-grade locks and hardware for high-traffic applications',
      },
      {
        icon: 'ri-truck-line',
        title: 'Complete Sets',
        description: 'Coordinated hardware packages for entire buildings',
      },
      {
        icon: 'ri-global-line',
        title: 'Global Brands',
        description: 'Access to premium hardware manufacturers worldwide',
      },
    ],
    products: [
      {
        name: 'Door Locks',
        description: 'Commercial and residential locksets in multiple finishes',
        image: 'https://readdy.ai/api/search-image?query=modern%20door%20lock%20and%20handle%20set%20in%20brushed%20nickel%20finish%20showing%20commercial%20grade%20quality%20and%20contemporary%20design%20on%20white%20background&width=600&height=500&seq=hardware-locks-001&orientation=portrait',
      },
      {
        name: 'Door Handles',
        description: 'Lever handles, knobs, and pull sets in various styles',
        image: 'https://readdy.ai/api/search-image?query=elegant%20door%20lever%20handles%20in%20multiple%20finishes%20including%20chrome%20and%20bronze%20displayed%20professionally%20showing%20modern%20architectural%20design&width=600&height=500&seq=hardware-handles-001&orientation=portrait',
      },
      {
        name: 'Hinges',
        description: 'Ball bearing and continuous hinges for commercial doors',
        image: 'https://readdy.ai/api/search-image?query=commercial%20grade%20door%20hinges%20in%20satin%20chrome%20finish%20showing%20heavy%20duty%20construction%20and%20professional%20quality%20on%20white%20surface&width=600&height=500&seq=hardware-hinges-001&orientation=portrait',
      },
      {
        name: 'Cabinet Hardware',
        description: 'Pulls, knobs, and hinges for kitchen and bath cabinetry',
        image: 'https://readdy.ai/api/search-image?query=modern%20cabinet%20hardware%20including%20pulls%20and%20knobs%20in%20brushed%20gold%20finish%20displayed%20on%20white%20surface%20with%20professional%20lighting&width=600&height=500&seq=hardware-cabinet-001&orientation=portrait',
      },
      {
        name: 'Access Control',
        description: 'Electronic locks, card readers, and keyless entry systems',
        image: 'https://readdy.ai/api/search-image?query=modern%20electronic%20door%20lock%20with%20keypad%20and%20card%20reader%20showing%20smart%20access%20control%20technology%20in%20commercial%20building%20entrance&width=600&height=500&seq=hardware-access-001&orientation=portrait',
      },
      {
        name: 'Architectural Fittings',
        description: 'Handrails, grab bars, and ADA-compliant accessories',
        image: 'https://readdy.ai/api/search-image?query=stainless%20steel%20architectural%20fittings%20including%20handrails%20and%20grab%20bars%20showing%20ADA%20compliant%20design%20and%20professional%20installation&width=600&height=500&seq=hardware-fittings-001&orientation=portrait',
      },
    ],
    specifications: [
      'ANSI Grade 1 and Grade 2 options available',
      'ADA-compliant hardware for accessibility',
      'Fire-rated hardware for rated assemblies',
      'Multiple finishes: chrome, bronze, nickel, black',
      'Master key systems available',
      'Electronic and mechanical options',
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <ProductTemplate data={productData} />
      <Footer />
    </div>
  );
};

export default HardwarePage;